import { ElementState } from "@creatomate/preview";
import { SubtitleSection } from "chq";
import getSectionElementByIndex from "./getSectionElementByIndex";

const updateNextElementsSubName = (
  index: number,
  section: SubtitleSection,
  elements: ElementState[]
): Record<string, any> => {
  const element = getSectionElementByIndex(index, elements);
  if (element) {
    const newName = element.source.name.replace(/sub-\d+-/, `sub-${section.index + 1}-`);
    return {
      ...element.source,
      name: newName
    };
  }

  return {};
};

export default updateNextElementsSubName;
